import React, { useState, useEffect } from 'react';
import Header from 'components/Header';
// import VerifyPhone from 'components/VerifyPhone';
import values from 'object.values';
import { useHistory } from 'react-router-dom';
import Input from 'components/libs/Input';
import classnames from 'classnames';
import Button from 'components/libs/Buttons';

import { goBack, getStoreId } from 'utils/';
import Checkbox from 'components/libs/Checkbox';

import { translate } from 'constants/language';
import {
  IS_ARABIC,
  COUNTRY,
  PHONE_CODE,
  CURRENT_LANG_PREFIX
} from 'constants/index';
import IconLock from 'assets/icons/icon-lock.svg';
import aeFlag from 'assets/images/uaeFlag.png';
import saFlag from 'assets/images/saudiFlag.png';
import kwFlag from 'assets/images/kuwaitFlag.png';
import QaFlag from 'assets/images/qatFlag.png';
import BhFlag from 'assets/images/bahFlag.png';
import InFlag from 'assets/images/indFlag.png';

import AddressIcon from 'assets/icons/account/myAddresses.svg';
import CardIcon from 'assets/icons/account/card.svg';
import ProfileIcon from 'assets/icons/account/profile.svg';

import { useStateValue } from 'context/app';

import {
  isValidPhone,
  isValidEmail,
  isValidFirstOrLastName
} from 'utils/validators';
import {
  profileUpdate,
  // verifyPhone,
  getLoginValidate,
  showToast,
  logout,
  sendOTP
} from 'containers/Account/actions';
import { isBrowser, isMobile, MobileView } from 'react-device-detect';
import ProfileIconSmall from 'assets/icons/my-account-24-px.svg';
import PasswordIcon from 'assets/icons/password-icon-24-px.svg';
import ListItem from './ListItem';
import AccountTitle from './AccountTitle';

export default () => {
  const history = useHistory();
  const flagObj = {
    ae: aeFlag,
    sa: saFlag,
    kw: kwFlag,
    bh: BhFlag,
    qa: QaFlag,
    in: InFlag
  };
  const [genders, setGenders] = useState([
    { selected: false, label: 'Female', value: 2 },
    { selected: false, label: 'Male', value: 1 }
  ]);
  const [ageGroups, setAgeGroups] = useState([]);
  const [customerAgeGroupId, setCustomerAgeGroupId] = useState();
  const [profileForm, setProfile] = useState({});
  const [countryCode, setCountryCode] = useState();
  const [profileError, setProfileError] = useState({
    firstName: false,
    lastName: false,
    email: false,
    mobile: false
  });
  const [initialProfile, setInitialProfile] = useState({});
  const [passwordAvailable, setPasswordAvailable] = useState(false);
  // const [showVerifyPhone, setShowVerifyPhone] = useState(false);
  const {
    account: [accountState, dispatch],
    shipping: [, shippingDispatch]
  } = useStateValue();

  const storeId = getStoreId();
  const phoneCodeArray = values(PHONE_CODE);
  const phoneCountryArray = Object.keys(PHONE_CODE);

  const trimMobile = mobileNum => {
    const requiredLength = COUNTRY.toLowerCase() === 'in' ? 10 : 9;
    let trimmedMobileNumber = mobileNum;
    if (mobileNum) {
      if (mobileNum.substr(0, 1) === '0') {
        trimmedMobileNumber = trimmedMobileNumber.substr(
          1,
          trimmedMobileNumber.length
        );
      } else {
        trimmedMobileNumber = trimmedMobileNumber.substr(0, requiredLength);
      }
    }
    return trimmedMobileNumber;
  };

  const handleAgeGroupChange = selectedId => {
    const { mobile, mobileNumber, phoneCountry } = initialProfile;

    if (!initialProfile.ageGroupId) {
      setInitialProfile({
        ...profileForm,
        ageGroupId: Number(selectedId),
        countryCode: initialProfile.countryCode,
        mobile,
        mobileNumber,
        phoneCountry
      });
    }

    setProfile({ ...profileForm, ageGroupId: Number(selectedId) });
    setAgeGroups(
      ageGroups.map(ageGroup => ({
        ...ageGroup,
        selected: ageGroup.id === selectedId
      }))
    );
  };

  const handleGenderChange = selectedGender => {
    setProfile({ ...profileForm, gender: selectedGender });
    setGenders(
      genders.map(gender => ({
        ...gender,
        selected: selectedGender === gender.value
      }))
    );
  };
  const handleProfileChange = event => {
    const profileData = profileForm;

    const { name, value } = event.target;

    if (name === 'mobile') {
      profileData[name] = value.replace(' ', '');
    } else {
      profileData[name] = value;
    }
    profileData.mobileNumber = `${profileData.countryCode} ${trimMobile(
      profileData.mobile
    )}`;
    setProfile({ ...profileData });
    switch (name) {
      case 'firstName':
        if (value && isValidFirstOrLastName(value)) {
          setProfileError({ ...profileError, firstName: false });
        }
        break;
      case 'lastName':
        if (value && isValidFirstOrLastName(value)) {
          setProfileError({ ...profileError, lastName: false });
        }
        break;
      case 'email':
        if (value && isValidEmail(value)) {
          setProfileError({ ...profileError, email: false });
        }
        break;
      case 'mobile':
        if (value && isValidPhone(value, storeId)) {
          setProfileError({ ...profileError, mobile: false });
        }
        break;
      default:
    }
  };

  useEffect(() => {
    handleAgeGroupChange(customerAgeGroupId);
  }, [customerAgeGroupId]);

  useEffect(() => {
    if (accountState.config && accountState.config.ageGroup) {
      setAgeGroups(
        (accountState.config.ageGroup[COUNTRY] &&
          accountState.config.ageGroup[COUNTRY].map(ageGroup => ({
            ...ageGroup,
            selected: ageGroup.id === customerAgeGroupId
          }))) ||
          []
      );
    }
  }, [accountState.config]);

  useEffect(() => {
    if (accountState.profile && accountState.profile.customer) {
      const customer = { ...accountState.profile.customer };
      let phoneArr = [];

      if (customer.passwordAvailable) {
        setPasswordAvailable(customer.passwordAvailable);
      }
      if (customer.mobileNumber) {
        if (customer.mobileNumber.split(' ').length < 2) {
          phoneCodeArray.forEach(pCode => {
            if (customer.mobileNumber.indexOf(pCode) !== -1) {
              phoneArr = [pCode, customer.mobileNumber.replace(pCode, '')];
            }
          });
        } else {
          phoneArr = customer.mobileNumber.split(' ');
        }
      }

      setCountryCode(
        customer.mobileNumber
          ? `${phoneArr[0] || PHONE_CODE[COUNTRY.toUpperCase()]}`
          : PHONE_CODE[COUNTRY.toUpperCase()]
      );

      handleGenderChange(customer.gender);
      setCustomerAgeGroupId(
        customer.ageGroupId ? customer.ageGroupId.toString() : ''
      );

      const customerAgeGroup = ageGroups.find(ageGroup => {
        if (customer.ageGroupId) {
          return ageGroup.id === customer.ageGroupId.toString();
        }
        return false;
      });
      const genderInfo = genders.find(gender => {
        return gender.value === customer.gender;
      });

      let phoneCountry = '';
      if (phoneArr[0]) {
        phoneCountry =
          phoneCountryArray[phoneCodeArray.indexOf(phoneArr[0])] &&
          phoneCountryArray[phoneCodeArray.indexOf(phoneArr[0])].toLowerCase();
      }
      const customerProfile = {
        firstName: customer.firstName,
        lastName: customer.lastName,
        email: customer.email,
        countryCode: customer.mobileNumber
          ? phoneArr[0]
          : PHONE_CODE[COUNTRY.toUpperCase()],
        phoneCountry,
        mobile: phoneArr[1],
        mobileNumber: customer.mobileNumber,
        gender: genderInfo && genderInfo.value,
        ageGroupId: customerAgeGroup && Number(customerAgeGroup.id)
      };

      setProfile({
        ...customerProfile,
        countryCode: phoneArr[0]
          ? phoneArr[0]
          : PHONE_CODE[COUNTRY.toUpperCase()],
        mobile: phoneArr[0] ? phoneArr[1] : customer.mobileNumber,
        mobileNumber: phoneArr[0]
          ? customer.mobileNumber
          : `${PHONE_CODE[COUNTRY.toUpperCase()]} ${customer.mobileNumber}`,
        phoneCountry: phoneCountry || COUNTRY.toLowerCase()
      });
      setInitialProfile({ ...customerProfile });
    } else {
      history.push(`/${CURRENT_LANG_PREFIX}/account/`);
    }
  }, [
    accountState.profile,
    accountState.profile && accountState.profile.customer
  ]);

  const closeMyProfile = () => {
    goBack(history);
  };

  const handleLogout = () => {
    logout({}, dispatch, shippingDispatch);
    history.push(`/${CURRENT_LANG_PREFIX}/account/`);
  };
  const goToNext = id => {
    return history.push(`/${CURRENT_LANG_PREFIX}/account/${id}`);
  };
  const handleError = () => {
    let hasError = false;
    let firstName = false;
    let lastName = false;
    let mobile = false;
    let email = false;
    if (!profileForm.firstName) {
      hasError = true;
      firstName = translate('Please enter a valid value');
    }
    if (
      profileForm.firstName &&
      !isValidFirstOrLastName(profileForm.firstName)
    ) {
      hasError = true;
      firstName = translate('No Special Characters allowed');
    }

    if (!profileForm.lastName) {
      hasError = true;
      lastName = translate('Please enter a valid value');
    }
    if (profileForm.lastName && !isValidFirstOrLastName(profileForm.lastName)) {
      hasError = true;
      lastName = translate('No Special Characters allowed');
    }

    if (!profileForm.email) {
      hasError = true;
      email = translate('Please enter a valid value');
    }

    if (profileForm.email && !isValidEmail(profileForm.email)) {
      hasError = true;
      email = translate('Invalid email. Can you check the format?');
    }

    if (!profileForm.mobile) {
      hasError = true;
      mobile = translate('Please enter a valid value');
    }

    if (profileForm.mobile && !isValidPhone(profileForm.mobile, storeId)) {
      hasError = true;
      mobile =
        [13, 12, 14, 16, 18, 20].indexOf(storeId) > -1
          ? translate('Please use a valid mobile number (eg. 50123456)')
          : translate('Please use a valid mobile number (eg. 501234567)');
    }

    setProfileError({ firstName, lastName, email, mobile });
    return hasError;
  };

  const handleConfirm = async () => {
    if (handleError()) {
      return false;
    }

    if (initialProfile.mobile !== trimMobile(profileForm.mobile)) {
      const validateResponse = await getLoginValidate(
        {
          useridentifier: profileForm.mobileNumber,
          loginType: 'MOBILE_LOGIN',
          initiatedFrom: 'profile'
        },
        dispatch
      );

      if (validateResponse.exists) {
        showToast(
          {
            type: 'error',
            content: translate(
              'Sorry, this mobile is already registered with us.'
            )
          },
          dispatch
        );
      } else {
        // verifyPhone({ phone: profileForm.mobileNumber }, dispatch);
        sendOTP(
          { phone: profileForm.mobileNumber, envokedFrom: 'profile' },
          dispatch
        );
      }
    } else {
      profileUpdate({ ...profileForm }, dispatch);
    }

    return true;
  };

  useEffect(() => {
    if (accountState.phoneVerified) {
      profileUpdate({ ...profileForm }, dispatch);
    }
  }, [accountState.phoneVerified]);

  useEffect(() => {
    if (accountState.profileUpdateSuccess && isMobile) {
      closeMyProfile();
    }
  }, [accountState.profileUpdateSuccess]);

  return (
    <>
      <AccountTitle
        title="My Account"
        icon={<ProfileIconSmall className="d-block" />}
        link=""
        title2={passwordAvailable ? 'Change Password' : ''}
        icon2={<PasswordIcon className="d-block" />}
        link2="changepassword"
        is2ndActive={false}
        rightCTA={
          <div
            className="flex center-xs"
            role="button"
            onClick={handleLogout}
            onKeyPress={handleLogout}
          >
            <div className="fs-14 lh-18 ls-064 fw-6 bb-brand-dashed pb-4">
              {translate('Sign out of my account')}
            </div>
          </div>
        }
      />

      <div className={classnames({ 'bg-thumb-gray': !isBrowser })}>
        <MobileView>
          <Header
            showLogo={false}
            title={translate('My Account')}
            backAction={closeMyProfile}
          />
          <div className="pl-15 pr-15 mb-4 mt-50 bg-white">
            <div className="flex middle-xs bb-light">
              <AddressIcon className="w-20" />
              <ListItem
                id="addresses"
                title="My Addresses"
                noBorder={true}
                onClick={goToNext}
              />
            </div>
            <If condition={COUNTRY.toLowerCase() !== 'in'}>
              <div className="flex middle-xs bb-light">
                <CardIcon className="w-20" />
                <ListItem
                  id="savedcards"
                  title="My Saved Cards"
                  noBorder={true}
                  onClick={goToNext}
                />
              </div>
            </If>
            <div className="flex middle-xs">
              <IconLock className="w-20" />
              <ListItem
                id="security-privacy"
                title="Security and Privacy"
                onClick={goToNext}
                noBorder={true}
              />
            </div>
          </div>
        </MobileView>
        <div
          className={classnames({
            'pl-15 pr-15 mb-4 pb-16 bg-white': !isBrowser
          })}
        >
          <MobileView>
            <div className="flex middle-xs bb-light">
              <ProfileIcon className="w-20" />
              <ListItem
                id="profileDetails"
                title="Profile Details"
                noBorder={true}
                rightAngle={false}
                isLink="true"
              />
            </div>
          </MobileView>
          <Input
            label={`*${translate('First Name')}`}
            labelClass="block ls-072 fs-12"
            className="r-ta-l"
            name="firstName"
            value={profileForm.firstName}
            dir="ltr"
            type="text"
            onChange={handleProfileChange}
            error={profileError.firstName}
            wrapClassNames={classnames('col-xs-12 mt-16', {})}
          />
          <Input
            label={`*${translate('Last Name')}`}
            labelClass="block ls-072 fs-12"
            className="r-ta-l"
            name="lastName"
            value={profileForm.lastName}
            dir="ltr"
            type="text"
            onChange={handleProfileChange}
            error={profileError.lastName}
            wrapClassNames={classnames('col-xs-12 mt-16', {})}
          />
          <Input
            label={`*${translate('Email')}`}
            labelClass="block ls-072 fs-12"
            className="r-ta-l"
            name="email"
            value={profileForm.email}
            dir="ltr"
            type="email"
            disabled={true}
            onChange={() => {}}
            error={profileError.email}
            wrapClassNames={classnames('col-xs-12 mt-16', {})}
          />
          <div className="row mt-16">
            <Input
              label={translate('Country code')}
              labelClass="block ls-072 fs-12"
              value={countryCode}
              className={classnames('r-ta-r w90p en-font', {})}
              prefix={
                <img
                  className="r-ml-15 mt-14 pos-abs h-24"
                  src={flagObj[profileForm.phoneCountry || COUNTRY]}
                  alt="flag"
                />
              }
              wrapClassNames={classnames('col-xs-4 r-pr-10', {})}
              disabled={true}
            />
            <Input
              label={`*${translate('Enter Mobile Number')}`}
              labelClass="block ls-072 fs-12"
              name="mobile"
              value={profileForm.mobile}
              type="tel"
              maxLength="10"
              dir="ltr"
              onChange={handleProfileChange}
              error={profileError.mobile}
              className={classnames('en-font r-ta-l', {})}
              wrapClassNames={classnames('col-xs-8 r-pl-10', {})}
              placeholder={
                COUNTRY.toLowerCase() === 'in' ? '' : 'Ex: 522626548'
              }
            />

            <div
              className={classnames(
                'flex col-xs-12 bt-light-gray',
                isBrowser
                  ? 'bb-light-gray pt-24 pb-24 mb-24 mt-24'
                  : 'pt-16 mt-15'
              )}
            >
              {genders.map((gender, index) => (
                <div
                  className={classnames('flex', {
                    'col-xs-7': index,
                    'col-xs-5': !index
                  })}
                  onClick={() => handleGenderChange(gender.value)}
                  onKeyPress={() => handleGenderChange(gender.value)}
                  role="button"
                >
                  <Checkbox checked={gender.selected} role="checkbox" />
                  <div
                    className={classnames('pl-8 pr-8 fs-14', {
                      'fw-6': gender.selected,
                      'pt-3': IS_ARABIC
                    })}
                  >
                    {translate(gender.label)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={classnames({ 'pl-15 pr-15 bg-white pb-25': !isBrowser })}
        >
          <div
            className={classnames(
              isBrowser
                ? 'pb-8 fs-16 lh-20 ls-048 c-dark-gray fw-6'
                : 'cap pt-16 pb-16 bb-light-gray fs-12 c-brown-gray'
            )}
          >
            {translate('Age Group')}
          </div>
          <div className={classnames('ta-l', { 'pr-10 pl-10': !isBrowser })}>
            {ageGroups.map(ageGroup => (
              <div
                className={classnames(
                  'flex',
                  isBrowser ? 'pt-8 pb-8' : 'bb-light-gray pt-16 pb-16 '
                )}
                onClick={() => handleAgeGroupChange(ageGroup.id)}
                onKeyPress={() => handleAgeGroupChange(ageGroup.id)}
                role="button"
              >
                <Checkbox checked={ageGroup.selected} role="checkbox" />

                <div
                  className={classnames('pl-8 pr-8 fs-14', {
                    'fw-6': ageGroup.selected,
                    'pt-3': IS_ARABIC
                  })}
                >
                  {IS_ARABIC ? ageGroup.value_ar : ageGroup.value}
                </div>
              </div>
            ))}
          </div>
          <MobileView>
            <div
              className="flex center-xs pb-20 mt-16 "
              role="button"
              onClick={handleLogout}
              onKeyPress={handleLogout}
            >
              <div className="fs-14 lh-18 fw-6 bb-brand-dashed pb-4">
                {translate('Sign out of my account')}
              </div>
            </div>
          </MobileView>
        </div>
        <div
          className={classnames(
            'bg-white bt-light-gray pb-15 ',
            isBrowser ? 'ta-r mt-16' : 'pl-15 pr-15'
          )}
        >
          <Button
            disabled={
              accountState.profileUpdateLoading ||
              JSON.stringify(profileForm) === JSON.stringify(initialProfile) ||
              accountState.otpLoading
            }
            className={classnames(
              'primary cap p-14',
              isBrowser ? 'w-270 mt-24' : 'w100p mt-15'
            )}
            onClick={handleConfirm}
          >
            <span className={classnames('fs-14 fw-6 ls-16 lh-20')}>
              {translate('SAVE CHANGES')}
            </span>
          </Button>
        </div>
        {/* <VerifyPhone
          showVerifyPhoneDialog={accountState.showVerifyPhone}
          phone={profileForm.mobileNumber}
        /> */}
      </div>
    </>
  );
};
